module.exports = __webpack_public_path__ + "stripe-logo@2x.png?332f39222f068541a09a6daa3d0ce04b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stripe-logo@2x.png
// module id = 1035
// module chunks = 0